module.exports = __webpack_public_path__ + "static/img/industriales1.2cd5381.png";